import { createFileRoute } from "@tanstack/react-router";
import { HolidayViewPage } from "@/site/pages/holidays";

// Old app's "My Holiday Reminders" page — keep the URL.
export const Route = createFileRoute("/reminders_/holiday")({
  component: HolidayViewPage,
});
